module.exports = __webpack_public_path__ + "static/img/ayopppk.c70359c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ayopppk.png
// module id = xfGg
// module chunks = 1